export function once(el, type, callback) {
    const typeArray = type ? type.split(' ') : [];
    const recursiveFunction = (e) => {
        e.target.removeEventListener(e.type, recursiveFunction);
        return callback(e);
    };

    for (let i = typeArray.length - 1; i >= 0; i--) {
        on(el, typeArray[i], recursiveFunction);
    }
}

export function on(el, type, callback) {
    if (el.addEventListener) {
        el.addEventListener(type, callback);
    } else {
        // IE8+ Support
        el.attachEvent(`on${type}`, () => {
            callback.call(el);
        });
    }
}

export function off(el, type, callback) {
    if (el.removeEventListener) {
        el.removeEventListener(type, callback);
    } else {
        // IE8+ Support
        el.detachEvent(`on${type}`, callback);
    }
}

export function isKeyboard(e) {
    return ['keydown', 'keypress', 'keyup'].indexOf(e.type) !== -1;
}

export function arrowKeyActions(event, up, down, left, right) {
    const e = event || window.event;

    if (up && e.keyCode === '38') up();
    else if (down && e.keyCode === '40') down();
    else if (left && e.keyCode === '37') left();
    else if (right && e.keyCode === '39') right();
}
